import EditIcon from "@mui/icons-material/Edit"
import { Box, CircularProgress, MenuItem } from "@mui/material"
import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogTitle from "@mui/material/DialogTitle"
import TextField from "@mui/material/TextField"
import { useFormik } from "formik"
import { useAppDispatch } from "hooks"
import { useState } from "react"
import deviceService from "services/deviceService"
import { updateDevice } from "slices/deviceSlice"
import type { IDevice, IUpdateDevice } from "types/deviceTypes"
import * as Yup from "yup"

type Props = {
  device: IDevice
}

export function UpdateDeviceDialog({ device }: Props) {
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [open, setOpen] = useState(false)

  const dispatch = useAppDispatch()

  const initialValues: IUpdateDevice = {
    name: device.name,
  }

  const updateUserGroupValidationScheme = Yup.object({
    name: Yup.string()
      .required("Please enter device name")
      .min(4, "Minimum length is 4 characters")
      .max(32, "Maximum length is 32 characters"),
  })

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: updateUserGroupValidationScheme,
    onSubmit: (values) => {
      setIsLoading(true)

      const deviceUpdate: IUpdateDevice = {
        name: values.name,
      }

      deviceService
        .updateDevice(device.id, deviceUpdate)
        .then((updatedDevice) => {
          dispatch(updateDevice(updatedDevice))
          setIsLoading(false)
          handleClose()
        })
        .catch((err) => {
          console.log(err)
          setIsLoading(false)
        })
    },
  })

  const handleClickOpen = () => {
    formik.resetForm()
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <div>
      <MenuItem onClick={handleClickOpen}>
        <EditIcon sx={{ marginRight: 1 }} />
        Update
      </MenuItem>
      <Dialog open={open} fullWidth maxWidth="sm">
        <form onSubmit={formik.handleSubmit}>
          <DialogTitle>Update Device</DialogTitle>
          <DialogContent>
            <TextField
              autoFocus
              margin="dense"
              id="name"
              label="Name"
              type="name"
              fullWidth
              variant="outlined"
              value={formik.values.name}
              onChange={formik.handleChange}
              error={formik.touched.name && Boolean(formik.errors.name)}
              helperText={formik.touched.name && formik.errors.name}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>Cancel</Button>
            <Box sx={{ m: 1, position: "relative" }}>
              <Button type="submit" disabled={isLoading}>
                Update
              </Button>
              {isLoading && (
                <CircularProgress
                  size={24}
                  sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    marginTop: "-12px",
                    marginLeft: "-12px",
                  }}
                />
              )}
            </Box>
          </DialogActions>
        </form>
      </Dialog>
    </div>
  )
}
